import { useSearchParams } from 'react-router-dom';
import '../../Modal/modal.css';
import PearsonLogo from '../../../../images/pearson_logo.png';

const RestoreItemsModal = ({
  setShowRestoreModal,
  itemsToRestore,
  currentPath,
  confirmRestore,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onModalpopupClose = () => {
    if (searchParams.has('restore')) {
      searchParams.delete('restore');
      setSearchParams(searchParams);
    }
    setShowRestoreModal(false);
  };

  const directories = (itemsToRestore || []).filter((item) => !item?.isFile);
  const files = (itemsToRestore || []).filter((item) => item?.isFile);
  const formattedPath = String(currentPath || '/').replace(/%20/g, ' ');

  return (
    <div className="modal-content-table">
      <table role="presentation" border="0" width="99%" cellSpacing="3" cellPadding="0">
        <tr align="left" valign="top">
          <td align="left" valign="middle">
            <span className="pagetitle">&nbsp;Restore Folders/Files</span>
          </td>
          <td align="right" valign="middle">
            <img
              src={PearsonLogo}
              title="Pearson Education"
              alt="Pearson Education"
              width="85"
              height="21"
              hspace="0"
              vspace="0"
              border="0"
            />
          </td>
          <td>
            <span
              className="close"
              role="button"
              tabIndex={0}
              aria-label="Close"
              onClick={onModalpopupClose}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onModalpopupClose();
                }
              }}
            >
              &times;
            </span>
          </td>
        </tr>
      </table>
      <div id="background" className="create-new-folder"></div>
      <div id="table" className="unzip-table">
        <table role="presentation" border="0" width="99%" cellSpacing="0" cellPadding="0">
          <tr align="left" valign="top">
            <td
              align="center"
              valign="top"
              className="instructions delete-folder-modal-main restore-items-modal-main"
            >
              <div className="delete-folder-modal-copy">
                <p className="delete-folder-note restore-items-note">
                  <strong>The following items will be restored in the following directory and re-published to live:</strong>
                  <strong className="delete-folder-path-text">{formattedPath}</strong>
                </p>
              </div>
              <div
                className="delete-folder-lists"
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  gap: '24px',
                  textAlign: 'center',
                }}
              >
                {directories.length > 0 && (
                  <div>
                    <h3 className="delete-folder-list-heading">Directory:</h3>
                    <ul className="delete-folder-list">
                      {directories.map((directory, index) => (
                        <li key={`${directory?.fileName || 'dir'}-${index}`}>
                          <strong>{index + 1}. {directory?.fileName}</strong>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {files.length > 0 && (
                  <div>
                    <h3 className="delete-folder-list-heading">Files:</h3>
                    <ul className="delete-folder-list">
                      {files.map((file, index) => (
                        <li key={`${file?.fileName || 'file'}-${index}`}>
                          <strong>{index + 1}. {file?.fileName}</strong>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="delete-folder-actions">
                <input
                  type="button"
                  className="unzip-formButton"
                  value="&nbsp;Cancel&nbsp;"
                  onClick={onModalpopupClose}
                />
                <input
                  type="button"
                  className="unzip-formButtonGo"
                  value="&nbsp;Restore&nbsp;"
                  onClick={confirmRestore}
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default RestoreItemsModal;
